/// <reference path="../app.ts" />
namespace Cfnc {
    export interface ISport {
        sportName: string;
        sportCode: string;
    }

    export interface ISportList {
        getSports: () => ISport[];
    }

    export class SportList implements ISportList {
        static serviceId: string = "sportList";

        constructor() {
        }

        getSports() {
            return [
                {
                    sportName: "Archery",
                    sportCode: "ARCH"
                },
                {
                    sportName: "Badminton",
                    sportCode: "BADMI"
                },
                {
                    sportName: "Baseball",
                    sportCode: "BASEB"
                },
                {
                    sportName: "Basketball",
                    sportCode: "BSKTB"
                },
                {
                    sportName: "Bicycling",
                    sportCode: "BICYC"
                },
                {
                    sportName: "Bowling",
                    sportCode: "BOWLG"
                },
                {
                    sportName: "Cheerleading",
                    sportCode: "CHEER"
                },
                {
                    sportName: "Crew",
                    sportCode: "CREW"
                },
                {
                    sportName: "Cross-Country",
                    sportCode: "XRUN"
                },
                {
                    sportName: "Equestrian Sports",
                    sportCode: "EQUES"
                },
                {
                    sportName: "Fencing",
                    sportCode: "FENCE"
                },
                {
                    sportName: "Field Hockey",
                    sportCode: "FHOCK"
                },
                {
                    sportName: "Football",
                    sportCode: "FOOTB"
                },
                {
                    sportName: "Golf",
                    sportCode: "GOLF"
                },
                {
                    sportName: "Gymnastics",
                    sportCode: "GYMNA"
                },
                {
                    sportName: "Ice Hockey",
                    sportCode: "HOCKE"
                },
                {
                    sportName: "Lacrosse",
                    sportCode: "LACRO"
                },
                {
                    sportName: "Racquetball",
                    sportCode: "RACQU"
                },
                {
                    sportName: "Riflery",
                    sportCode: "RIFLE"
                },
                {
                    sportName: "Rugby",
                    sportCode: "RUGBY"
                },
                {
                    sportName: "Sailing",
                    sportCode: "SAILG"
                },
                {
                    sportName: "Skiing (downhill)",
                    sportCode: "SKIIN"
                },
                {
                    sportName: "Soccer",
                    sportCode: "SOCCR"
                },
                {
                    sportName: "Softball",
                    sportCode: "SOFTB"
                },
                {
                    sportName: "Squash",
                    sportCode: "SQUAS"
                },
                {
                    sportName: "Strength & Conditioning",
                    sportCode: "STRE3"
                },
                {
                    sportName: "Swimming",
                    sportCode: "SWIM"
                },
                {
                    sportName: "Tennis",
                    sportCode: "TENNI"
                },
                {
                    sportName: "Track and Field",
                    sportCode: "TRACK",
                },
                {
                    sportName: "Ultimate Frisbee",
                    sportCode: "ULTIM"
                },
                {
                    sportName: "Volleyball",
                    sportCode: "VOLLB"
                },
                {
                    sportName: "Water Polo",
                    sportCode: "WPOLO"
                },
                {
                    sportName: "Water Skiing",
                    sportCode: "00024"
                },
                {
                    sportName: "Weight Lifting",
                    sportCode: "WLIFT"
                },
                {
                    sportName: "Winter (Indoor) Track",
                    sportCode: "00031"
                },
                {
                    sportName: "Wrestling",
                    sportCode: "WREST"
                }
            ];
        }
    }

    angular.module("app").service(SportList.serviceId, SportList);
}